import { generateClassName, getColorVariantFromBackground } from '@klv/shared/utils/functions';
import { Anchor } from '@klv/atoms/anchor';
import type { ElementType } from 'react';

import * as styles from './styles/blogCategoryButton.module.scss';

import type { IBlogCategoryButton } from './types';

const BlogCategoryButton = ({
  afterText = '',
  backgroundColor,
  buttonTag,
  className = '',
  link,
  name,
  ...props
}: IBlogCategoryButton) => {
  const colorVariant = getColorVariantFromBackground(backgroundColor ?? 'light');
  const Tag = (buttonTag ? buttonTag : Anchor) as ElementType;

  return (
    <div className={generateClassName([className, styles.detailsRow, 'blogCategoryButton'])} {...props}>
      <Tag
        className={generateClassName(['formRegular', styles.categoryLink])}
        href={link}
      >
        {name}
      </Tag>
      {afterText && (
        <div className={generateClassName(['formRegular', styles.blogDate, styles[colorVariant]])}>
          {afterText}
        </div>
      )}
    </div>
  );
};

export default BlogCategoryButton;
